import { FC } from 'react';

import Link from 'next/link';

import { useRecoilValue } from 'recoil';

import { sellerIsLoggedIn } from '@recoil_iqfu/atoms/public/login_state';

import styles from './NotFoundCompanies.module.scss';

type Props = { pageLabel?: string; showDefaultLinks?: boolean };

const NotFoundCompanies: FC<Props> = ({ showDefaultLinks = true }) => {
  const isLoggedIn = useRecoilValue(sellerIsLoggedIn);
  return (
    <div className={styles.content}>
      <div className={styles.ikuko_wrapper}>
        <img src="/images/iqfu/public/ikuko_search.svg" className={styles.ikuko} alt="イク子さん" />
      </div>

      <div className={styles.head_text}>
        申し訳ございません。お探しの地域で該当の不動産屋さんが登録されておりません。
      </div>

      {showDefaultLinks && (
        <div className={styles.buttons_container}>
          <Link
            href={isLoggedIn ? '/chat/talk?redirect=contact' : '/signup_inquiry'}
            prefetch={false}
            className={styles.start_chat_button}
          >
            イクラ不動産に探してもらう
          </Link>
          <Link href={'/'} prefetch={false} passHref className={styles.top_page_link}>
            イクラ不動産トップへ
          </Link>
        </div>
      )}
    </div>
  );
};

export default NotFoundCompanies;
